<template>
    <div class="colored-cards" v-if="cards.length">
        <div class="row">
            <div
                v-for="item in cards"
                :class="columnClass"
                :key="item.color"
            >
                <z-card
                    class="colored-cards__card"
                    :link="item.link"
                    :class="`z-card--${item.color}`"
                    :artline="false"
                    :theme="item.theme"
                    :border="false"
                >
                    <template v-slot:title>
                        <z-tooltip
                            :content="item.text"
                            v-if="item.text"
                            placement="bottom"
                            inverted
                        >
                            <span class="white-text" v-html="item.title"></span>
                        </z-tooltip>
                        <span v-else class="white-text" v-html="item.title"></span>
                    </template>
                </z-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'colored-cards',
    props: {
        cards: {
            type: Array,
            default: () => []
        },
        columnClass: {
            type: String,
            default: 'col-default-3 col-tablet-6 col-v-tablet-12'
        }
    }
}
</script>

<style lang="scss">
.colored-cards {
    .col-default-3 {
        .z-card {
           &__content {
               font-size: 15px;
               line-height: 1.3;
            }
        }
    }

    [class*="col-"] {
        display: flex;
    }

   .z-card {
        display: inline-block;
        width: 100%;

        &__body {
            min-height: 170px;
            padding: $token-spacers-xl 28px;
        }

        &__title {
            overflow: visible;
        }

        &__content {
            @include breakpoint (mobile) {
               font-size: 15px;
               line-height: 1.3;
            }
        }

        &--evraz-red-light {
           background-color: #EE3C2F;
        }

        &--evraz-orange-light {
           background-color: #F19041;
        }

        &--evraz-yellow {
           background-color: #FBB92F;
        }

        &--evraz-red {
           background-color: #E42213;
        }

        &--evraz-orange {
           background-color: #EE7918;
        }

        &--evraz-yellow-dark-1 {
           background-color: #F9AF10;
        }

        &--evraz-red-dark {
           background-color: #BD1B0F;
        }

        &--evraz-orange-dark {
           background-color: #DC6503;
        }

        &--evraz-yellow-dark-2 {
           background-color: #EFA506;
        }

        &--white {
           background-color: $token-colors-white;
        }

        &--gray-superlight {
           background-color: token-colors-gray-superlight;
        }

        &--gray-light {
           background-color: #F1F1F1;
        }
    }
}
</style>
